import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

import BarChartIcon from '@/shared/assets/bar_chart.svg?react';
import BatteryChartIcon from '@/shared/assets/battery_chart_icon.svg?react';
import LineChartIcon from '@/shared/assets/line_chart.svg?react';
import PieChartIcon from '@/shared/assets/pie_chart.svg?react';

export enum AggregationType {
  TIMELINE = 'timeline',
  ACCUMULATED = 'accumulated',
}

export const AggregationIntervalls = [
  'daily',
  'weekly',
  'monthly',
  'quarterly',
  'yearly',
] as const;
export type AggregationIntervall = (typeof AggregationIntervalls)[number];

export const aggregationIntervallToString = (
  aggregation: AggregationIntervall,
) => {
  const { t } = useTranslation('chart', {
    keyPrefix: 'aggregation_intervalls',
  });
  switch (aggregation) {
    case 'daily':
      return t('daily');
    case 'weekly':
      return t('weekly');
    case 'monthly':
      return t('monthly');
    case 'quarterly':
      return t('quarterly');
    case 'yearly':
      return t('yearly');
    default:
      return '';
  }
};

export const aggregationToString = (aggregation: AggregationType) => {
  const { t } = useTranslation('chart', { keyPrefix: 'aggregation_types' });
  switch (aggregation) {
    case 'timeline':
      return t('timeline');
    case 'accumulated':
      return t('accumulated');
    default:
      return '';
  }
};

export enum ChartType {
  LINE = 'line',
  BATTERY = 'battery',
  BAR = 'bar',
  PIE = 'pie',
  ONE_NUMBER = 'one_number',
}

export const chartToIcon = (chart: ChartType) => {
  switch (chart) {
    case 'line':
      return <LineChartIcon className="size-4" />;
    case 'battery':
      return <BatteryChartIcon className="size-4" />;
    case 'bar':
      return <BarChartIcon className="size-4" />;
    case 'pie':
      return <PieChartIcon className="size-4" />;
    default:
      return null;
  }
};

export const chartToString = (
  chart: ChartType,
  t: TFunction<'chart', 'chart_types'>,
) => {
  switch (chart) {
    case 'line':
      return t('line');
    case 'battery':
      return t('battery');
    case 'bar':
      return t('bar');
    case 'pie':
      return t('pie');
    case 'one_number':
      return t('one_number');
    default:
      return '';
  }
};
